import {
  Breadcrumb,
  Button,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Space,
  Switch,
  Table,
  Tooltip,
} from "antd";
import { LockOutlined } from "@ant-design/icons";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import PasswordField from "../../common/htmlComponents/PasswordField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { ReactComponent as PasswordIcon } from "../../image/Password.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

const CompanyOnboardingList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [CompanyOnboarding, setCompanyOnboarding] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [vendor, setVendor] = useState([]);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [passwordRecord, setPasswordRecord] = useState(null);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordForm] = Form.useForm();
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10
  });

  // useEffect to fetch company onboarding list when state, reload, or translation function 't' changes
  useEffect(() => {
    const getCompanyOnboardingList = async () => {
      setLoading(true);
        const fields = [
          "id",
          "name",
          "first_name",
          "designation",
          "email",
          "phone",
          "registered_business_address_area",
          "registered_business_address_city",
          "registered_business_address_state",
          "registered_business_address_pincode_number",
          "website",
          "no_of_employees",
          "company_pan",
          "gst_no",
          "cin_no",
          "sector_name",
          "is_active",
          "is_new",
        ].join(",");

        // Construct query parameters
        const queryParams = new URLSearchParams({
          fields: fields,
          page: state.page,
          page_size: state.pagesize,
          ordering: state.ordering,
          ...(state.search && { search: state.search }),
        });
      try {
        let apiResponse = await getRequest(`company/?${queryParams.toString()}`, state);

        if (apiResponse.data.results.success) {
          setCompanyOnboarding(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_company_onboarding_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getCompanyOnboardingList();
  }, [state, reload, t]);

  // Handle changes in the table's pagination, filters, sorting, and ordering
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };


// Function to map sorting field and order to the corresponding API sorting key
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }
    if (sortField === "first_name" && sortOrder === "ascend") {
      sortingEnumKey = "first_name";
    }
    if (sortField === "first_name" && sortOrder === "descend") {
      sortingEnumKey = "-first_name";
    }
    if (sortField === "designation" && sortOrder === "ascend") {
      sortingEnumKey = "designation";
    }
    if (sortField === "designation" && sortOrder === "descend") {
      sortingEnumKey = "-designation";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }
    if (sortField === "address_line_1" && sortOrder === "ascend") {
      sortingEnumKey = "address_line_1";
    }
    if (sortField === "address_line_1" && sortOrder === "descend") {
      sortingEnumKey = "-address_line_1";
    }

    if (sortField === "address_line_2" && sortOrder === "ascend") {
      sortingEnumKey = "address_line_2";
    }
    if (sortField === "address_line_2" && sortOrder === "descend") {
      sortingEnumKey = "-address_line_2";
    }

    if (sortField === "city" && sortOrder === "ascend") {
      sortingEnumKey = "city";
    }
    if (sortField === "city" && sortOrder === "descend") {
      sortingEnumKey = "-city";
    }

    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state";
    }

    if (sortField === "pincode_number" && sortOrder === "ascend") {
      sortingEnumKey = "pincode__pincode_number";
    }
    if (sortField === "pincode_number" && sortOrder === "descend") {
      sortingEnumKey = "-pincode__pincode_number";
    }

    if (sortField === "website" && sortOrder === "ascend") {
      sortingEnumKey = "website";
    }
    if (sortField === "website" && sortOrder === "descend") {
      sortingEnumKey = "-website";
    }

    if (sortField === "no_of_employees" && sortOrder === "ascend") {
      sortingEnumKey = "no_of_employees";
    }
    if (sortField === "no_of_employees" && sortOrder === "descend") {
      sortingEnumKey = "-no_of_employees";
    }

    if (sortField === "company_pan" && sortOrder === "ascend") {
      sortingEnumKey = "company_pan";
    }
    if (sortField === "company_pan" && sortOrder === "descend") {
      sortingEnumKey = "-company_pan";
    }

    if (sortField === "gst_no" && sortOrder === "ascend") {
      sortingEnumKey = "gst_no";
    }
    if (sortField === "gst_no" && sortOrder === "descend") {
      sortingEnumKey = "-gst_no";
    }
    if (sortField === "cin_no" && sortOrder === "ascend") {
      sortingEnumKey = "cin_no";
    }
    if (sortField === "cin_no" && sortOrder === "descend") {
      sortingEnumKey = "-cin_no";
    }
    if (sortField === "sector_name" && sortOrder === "ascend") {
      sortingEnumKey = "sector_name";
    }
    if (sortField === "sector_name" && sortOrder === "descend") {
      sortingEnumKey = "-sector_name";
    }

    return sortingEnumKey;
  };

  // Handle search input with a delay to avoid frequent API calls
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  // Function to update state with the search value
  const onSearch = (value) => {
      if (value) {
          setState({
              ...state,
              search: value,
          });
      } else {
          const { search, ...newState } = state; // Remove 'search' key from state
          setState(newState);
      }
  };


// Configuration for row selection in the table
  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
          (key) => !changeRows.find((row) => row.id === key)
        );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };


// Debounce function to delay search input handling
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);


// Handle archiving of selected companies
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("company-delete/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids?.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("company_onboarding_archive_successfully1"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
        ErrorNotificationMsg(t("error_in_archive_company_onboarding"));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const openPasswordModal = (record) => {
    setPasswordRecord(record);
    setPasswordModalOpen(true);
    passwordForm.resetFields();
  };

  const closePasswordModal = () => {
    setPasswordModalOpen(false);
    setPasswordRecord(null);
    passwordForm.resetFields();
  };

  const handleSetPassword = async (values) => {
    setPasswordLoading(true);
    try {
      const apiResponse = await postRequest("company-reset-password/", {
        company_id: passwordRecord?.id,
        password1: values.password,
        password2: values.confirm_password,
      });

      if (apiResponse.data?.success) {
        SuccessNotificationMsg(
          apiResponse.data.message || "Password set successfully"
        );
        closePasswordModal();
        setReload((r) => !r);
      } else {
        ErrorNotificationMsg(
          apiResponse.data?.message || "Failed to set password"
        );
      }
    } catch (error) {
      ErrorNotificationMsg("Failed to set password");
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleToggleStatus = async (record, checked) => {
      // Set loading for this row
      setVendor(prev => prev.map(v => v.id === record.id ? { ...v, _statusLoading: true } : v));
      try {
        const apiResponse = await postRequest(
          `company/toggle_active/?company_id=${record.id}`,
          { action: checked }
        );
        if (apiResponse.data && apiResponse.data.success) {
          SuccessNotificationMsg(apiResponse.data.message || "Status updated");
          setReload(r => !r); // reload list
        } else {
          ErrorNotificationMsg(apiResponse.data.message || "Failed to update status");
          setVendor(prev => prev.map(v => v.id === record.id ? { ...v, _statusLoading: false } : v));
        }
      } catch (error) {
        ErrorNotificationMsg("Failed to update status");
        setVendor(prev => prev.map(v => v.id === record.id ? { ...v, _statusLoading: false } : v));
      }
    };

  const columns = [
    {
      title: "Client Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 180
    },
    {
      title: "Person Name",
      dataIndex: "first_name",
      key: "first_name",
      sorter: true,
      width: 150
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      sorter: true,
      width: 130
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: true,
      width: 190
    },
    {
      title: "Contact Number",
      width: 160,
      dataIndex: "phone",
      key: "phone",
      render: (phone) => <>+{phone} </>,
      sorter: true,
    },
    {
      title: "Address Line 1",
      dataIndex: "registered_business_address_area",
      key: "registered_business_address_area",
      sorter: true,
      width: 160
    },
    {
      title: "City",
      dataIndex: "registered_business_address_city",
      key: "registered_business_address_city",
      sorter: true,
      width: 130
    },
    {
      title: "State",
      dataIndex: "registered_business_address_state",
      key: "registered_business_address_state",
      sorter: true,
      width: 130

    },

    {
      title: "Pincode",
      dataIndex: "registered_business_address_pincode_number",
      key: "registered_business_address_pincode_number",
      sorter: true,
      width: 130

    },
    {
      title: "Website",
      dataIndex: "website",
      key: "website",
      sorter: true,
      width: 130

    },
    {
      title: "Number Of Employee",
      dataIndex: "no_of_employees",
      key: "no_of_employees",
      sorter: true,
      width: 150

    },
    {
      title: "PAN Number",
      dataIndex: "company_pan",
      key: "company_pan",
      sorter: true,
      width: 130
    },
    {
      title: "GST Number",
      dataIndex: "gst_no",
      key: "gst_no",
      sorter: true,
      width: 180
    },
    {
      title: "CIN Number",
      dataIndex: "cin_no",
      key: "cin_no",
      sorter: true,
      width: 150
    },
    {
      title: "Sector",
      dataIndex: "sector_name",
      key: "sector_name",
      sorter: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 110,
      fixed:'right',
      render: (text, record) => (
        <Switch
          checked={record.is_active === true}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          loading={record._statusLoading}
          onChange={checked => handleToggleStatus(record, checked)}
          disabled={record.is_new}
        />
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 130,
      render: (text, record) => (
        <Space>
          <Link
            to={{
              pathname: "/company-onboarding/edit/" + btoa(record.id),
            }}
          >
            {authUserData()?.permission.includes("company|change_company") && (
              <Editicon />
            )}
          </Link>


          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            {authUserData()?.permission.includes("company|delete_company") && (
              <Archive style={{ cursor: "pointer" }} />
            )}
          </Popconfirm>
          
          {authUserData()?.permission.includes("company|change_company") &&
            (
            <Tooltip title="Set Password">
              <PasswordIcon
                style={{ cursor: "pointer" }}
                onClick={() => openPasswordModal(record)}
              />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Efficiently onboard new clients and manage client information, keyperson, and documents.
                </span>
              }
            >
              <h3>Company Listing</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("companyOnboarding")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {authUserData()?.permission.includes("company|add_company") && (
              <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    Add a new client with detailed contact and project information.
                  </span>
                }
              >
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={() => navigate("/company-onboarding/add")}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("addCompany")}
                </Button>
              </Tooltip>
            )}
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                {authUserData()?.permission.includes(
                  "company|delete_company"
                ) && (
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label={t("pl_archive")}
                    />
                  )}
              </Popconfirm>
            )}
            {authUserData()?.permission.includes("company|delete_company") && (
              <Tooltip placement="topLeft" title="Archived Records">
                <Link to="/company-onboarding/archive">
                  <Archiveicon />
                </Link>
              </Tooltip>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <Row className="tblheader">
          </Row>
<div className="tablewrp">
          <Table
            scroll={{
              x: 2600,
            }}
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={CompanyOnboarding}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>

      <Modal
        className="ModelPopupSec"
        title="Set Password"
        open={passwordModalOpen}
        onCancel={closePasswordModal}
        footer={null}
        destroyOnClose
        wrapClassName="modal-wrapper"
        keyboard={false}
      >
        <Form
          form={passwordForm}
          layout="vertical"
          onFinish={handleSetPassword}
        >
          <Form.Item label="Email">
            <Input value={passwordRecord?.email || ""} disabled />
          </Form.Item>
          <PasswordField
            name="password"
            placeholder="Enter password"
            prefix={<LockOutlined className="site-form-item-icon" />}
          />
          <Form.Item
            name="confirm_password"
            label="Confirm Password"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Please confirm the password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Confirm password"
            />
          </Form.Item>
          <div className="bottomButtons" style={{ textAlign: "right" }}>
            <Space>
              <ButtonField
                type="primary"
                className="CancelGradiantBtn"
                htmlType="button"
                label={t("cancel")}
                onClick={closePasswordModal}
              />
              <ButtonField
                type="primary"
                className="SaveGradiantBtn"
                htmlType="submit"
                label="Set Password"
                loading={passwordLoading}
              />
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default CompanyOnboardingList;
